// TODO: should be marked as server-only
// import 'server-only';
import { cache as memoizedCache } from 'react';
import { Locale } from '@headless-workspace/config';
import { CommonDI, FooterSlotsRepositoryType } from '../../../DI';

export const getMemoFooterSlots = memoizedCache(async (locale: Locale) =>
    CommonDI.get(FooterSlotsRepositoryType).getFooterInformation(locale),
);
